module.exports = __webpack_public_path__ + "static/media/img_5.bb861c36.png";